import { idLikeSchema } from '@zaoblako/shared/modules/serde/schemas/id-like.schema';
import type { SerdeTransformFunctionInterface } from '@zaoblako/shared/modules/serde/interfaces/serde-transform-function.interface';
import type { SerdeContextDataInterface } from '@zaoblako/shared/modules/serde/interfaces/serde-context-data.interface';
import type { SerdeContextInterface } from '@zaoblako/shared/modules/serde/interfaces/serde-context.interface';

import * as yup from 'yup'

/** Common validation schema for any entity-like objects: anything which contains numeric `id` field */
export const entityLikeSchema: yup.Schema<any> = yup.object({
  id: idLikeSchema,
});

/** Strict version of {@link entityLikeSchema} - `id` field is required */
export const entityLikeSchemaStrict: yup.Schema<any> = yup.object({
  id: idLikeSchema.required(),
});

/**
 * Factory function which creates serializer which use concrete type of entity-like schema
 * depends on received callback execution result
 *
 * @param cb Callback to compute concrete schema to use. Receives context as first argument.
 * Must return boolean value: if `true`, then strict schema will be used, otherwise base schema will be used
 *
 * @returns Serialized function ready to use
 */
export function entityLikeSchemaFactory<D extends SerdeContextDataInterface, V = unknown>(
  cb: (context: SerdeContextInterface<D, V>) => boolean
): SerdeTransformFunctionInterface<any> {
  return (context): yup.Schema<any> => cb(<any>context) ? entityLikeSchemaStrict : entityLikeSchema;
}
